import { mapState, mapMutations } from 'vuex'

import hotkeys from 'hotkeys-js'

export default {
  components: {
    'd2-panel-search': () => import('../components/panel-search/index.vue')
  },
  mounted () {
    // 绑定搜索功能快捷键 [ 打开 ]
    // @ts-ignore
    hotkeys(this.searchHotkey.open, event => {
      event.preventDefault()
      // @ts-ignore
      this.searchPanelOpen()
    })
    // 绑定搜索功能快捷键 [ 关闭 ]
    // @ts-ignore
    hotkeys(this.searchHotkey.close, event => {
      event.preventDefault()
      // @ts-ignore
      this.searchPanelClose()
    })
  },
  beforeDestroy () {
    // @ts-ignore
    hotkeys.unbind(this.searchHotkey.open)
    // @ts-ignore
    hotkeys.unbind(this.searchHotkey.close)
  },
  computed: {
    ...mapState('d2admin', {
      searchActive: (state: any) => state.search.active,
      searchHotkey: (state: any) => state.search.hotkey
    })
  },
  methods: {
    ...mapMutations({
      searchToggle: 'd2admin/search/toggle',
      searchSet: 'd2admin/search/set'
    }),
    /**
     * 接收点击搜索按钮
     */
    handleSearchClick () {
      // @ts-ignore
      this.searchToggle()
      // @ts-ignore
      if (this.searchActive) {
        setTimeout(() => {
          // @ts-ignore
          if (this.$refs.panelSearch) {
            // @ts-ignore
            this.$refs.panelSearch.focus()
          }
        }, 500)
      }
    },
    searchPanelOpen () {
      // @ts-ignore
      if (!this.searchActive) {
        // @ts-ignore
        this.searchSet(true)
        setTimeout(() => {
          // @ts-ignore
          if (this.$refs.panelSearch) {
            // @ts-ignore
            this.$refs.panelSearch.focus()
          }
        }, 500)
      }
    },
    // 关闭搜索面板
    searchPanelClose () {
      // @ts-ignore
      if (this.searchActive) {
        // @ts-ignore
        this.searchSet(false)
      }
    }
  }
}
